export default "__VITE_ASSET__gL1M_lon__"